import { Anchor, Box, Button, Spinner } from '@zillow/constellation-10';

import { useGetUser } from '../../hooks/queries/user';

import { paths as zrmPaths } from '../../utils/zrmPathsManifest';

import SignInCTA from '../SignInCTA';

import { inheritColorClass } from '../../styles';

const monetizationPageLink =
  'https://www.zillow.com/rental-manager/c/property-management-services/?utm_source=zillow&utm_medium=zrm-landing-page&utm_campaign=launch-property-management-services';
const POST_FIRST_LISTING_URL_QUERY = '?postingPath=true';

type Props = {
  canAccessLandingPageMonetization?: boolean;
  trackOptimizelyEvent?: (arg: string) => void;
};

const LandingPageCTA = ({ canAccessLandingPageMonetization = false, trackOptimizelyEvent }: Props) => {
  const { data: userData, isLoading } = useGetUser();

  if (isLoading) {
    return (
      <Box css={{ height: '54px' }}>
        <Spinner size="md" />
      </Box>
    );
  }

  const {
    summary: { totalListingCount },
  } = userData;

  const hasAnyListings = !!totalListingCount;

  return (
    <>
      <Box
        css={{
          display: 'flex',
          flexDirection: { base: 'column', md: 'row' },
          flexWrap: { md: 'wrap' },
          justifyContent: 'center',
        }}
      >
        {hasAnyListings ? (
          <Anchor
            className={inheritColorClass}
            onClick={() => trackOptimizelyEvent?.('HeroCtaViewProperties')}
            href={zrmPaths.propertiesPage}
          >
            <Button emphasis="filled" tone="brand">
              View your properties
            </Button>
          </Anchor>
        ) : (
          <Anchor
            className={inheritColorClass}
            onClick={() => trackOptimizelyEvent?.('HeroCtaPostListingFree')}
            href={`${zrmPaths.propertiesPage}${POST_FIRST_LISTING_URL_QUERY}`}
          >
            <Button emphasis="filled" tone="brand">
              List your properties for free
            </Button>
          </Anchor>
        )}
        {canAccessLandingPageMonetization && (
          <Box css={{ marginLeft: { base: 0, md: '400' }, marginTop: { base: '400', md: 0 } }}>
            <Anchor
              className={inheritColorClass}
              onClick={() => trackOptimizelyEvent?.('ZRMViewPaidServicesHeroClick')}
              href={monetizationPageLink}
            >
              <Button emphasis="outlined" tone="brand" css={{ width: '184px' }}>
                View paid services
              </Button>
            </Anchor>
          </Box>
        )}
      </Box>

      <SignInCTA />
    </>
  );
};

export default LandingPageCTA;
